exports.EDGE_LEGACY_VERSION = 18;

exports.headerHiddenBrowsers = [
  'iemobile',
  'opera',
  'waterfox',
];

exports.iconDesktopBrowsers = [
  'chrome',
  'edge',
  'firefox',
  'safari',
];

exports.iconMobileBrowsers = [
  'android',
  'ios',
];

exports.showShareBrowsers = [
  'ecosia android',
  'ecosia ios',
];
